export const DELIVERY_PARTNERS = {
  DPD: 'dpd',
  GLS: 'gls',
  UPS: 'ups',
  RABEN: 'raben',
  DACHSER: 'dachser',
  HERMES: 'hermes',
} as const;

export const DELIVERY_METHODS = [
  { name: DELIVERY_PARTNERS.DPD, logo: '/delivery/dpd.svg' },
  { name: DELIVERY_PARTNERS.GLS, logo: '/delivery/gls.svg' },
  { name: DELIVERY_PARTNERS.UPS, logo: '/delivery/ups.svg' },
  { name: DELIVERY_PARTNERS.RABEN, logo: '/delivery/raben.svg' },
  { name: DELIVERY_PARTNERS.DACHSER, logo: '/delivery/dachser.svg' },
  { name: DELIVERY_PARTNERS.HERMES, logo: '/delivery/hermes.svg' },
] as const;
